import { Animation as BJSAnimation } from "@babylonjs/core/Animations/animation";
import { CubicEase, EasingFunction } from "@babylonjs/core/Animations/easing";
export class Animation {
    /**
     * duration: time in seconds
     */
    static BackToStart(coreApp, pAnimateOptions, duration, onAfter) {
        this.mCoreApp = coreApp;
        this.onAnimationEnd = this.onAnimationEnd.bind(this);
        const tnbFrames = 50;
        const ttarget = pAnimateOptions.EndTarget.clone();
        const tDir = (pAnimateOptions.EndPos.subtract(ttarget)).normalize();
        const tEndTarget = pAnimateOptions.EndPos.subtract(tDir.scale(15));
        // create two animations that should happen simultaneously
        const animations = [
            // move the camera position
            this.animMove(pAnimateOptions.EndPos, tnbFrames),
            // move the camera target
            this.animTarget(tEndTarget, tnbFrames),
        ];
        // start both animations
        this.mCoreApp.viewer.onDemandRenderingEnabled = false;
        this.mCoreApp.scene.beginDirectAnimation(this.mCoreApp.viewer.view.camera, animations, 0, tnbFrames, false, 1 / duration, this.onAnimationEnd(pAnimateOptions, onAfter));
    }
    static start(coreApp, duration, onAfter) {
        if (this.mEndPos == null || this.mEndTarget == null)
            return;
        this.mCoreApp = coreApp;
        let tanimOpt = {};
        tanimOpt.StartPos = this.mCoreApp.viewer.view.camera.position.clone();
        tanimOpt.StartTarget = this.mCoreApp.viewer.view.camera.getTarget();
        tanimOpt.EndPos = this.mEndPos;
        tanimOpt.EndTarget = this.mEndTarget;
        this.BackToStart(coreApp, tanimOpt, duration, this.onAfterBack);
    }
    static onAnimationEnd(pAnimateOptions, onAfter) {
        return () => {
            if (this.mCoreApp == null || this.mCoreApp.viewer.view == null) {
                return;
            }
            this.mCoreApp.viewer.onDemandRenderingEnabled = true;
            this.mCoreApp.viewer.view.cameraControl.setPosition(pAnimateOptions.EndPos);
            this.mCoreApp.viewer.view.cameraControl.setTarget(pAnimateOptions.EndTarget);
            this.mCoreApp.viewer.requestRenderFrame();
            if (onAfter != null) {
                onAfter();
            }
        };
    }
    static animMove(pos, nbFrames) {
        var _a, _b;
        const anim = new BJSAnimation('movecam', 'position', nbFrames, BJSAnimation.ANIMATIONTYPE_VECTOR3, BJSAnimation.ANIMATIONLOOPMODE_CONSTANT);
        anim.setKeys([
            { frame: 0, value: (_a = this.mCoreApp) === null || _a === void 0 ? void 0 : _a.viewer.view.camera.position.clone() },
            { frame: nbFrames * 0.3, value: (_b = this.mCoreApp) === null || _b === void 0 ? void 0 : _b.viewer.view.camera.position.clone() },
            { frame: nbFrames, value: pos },
        ]);
        //easing
        const easingFun = new CubicEase();
        easingFun.setEasingMode(EasingFunction.EASINGMODE_EASEOUT);
        anim.setEasingFunction(easingFun);
        return (anim);
    }
    static animTarget(lookAt, nbFrames) {
        var _a;
        const anim = new BJSAnimation('lookcam', 'target', nbFrames, BJSAnimation.ANIMATIONTYPE_VECTOR3);
        anim.setKeys([
            { frame: 0, value: (_a = this.mCoreApp) === null || _a === void 0 ? void 0 : _a.viewer.view.camera.target.clone() },
            { frame: nbFrames * 0.3, value: lookAt },
            { frame: nbFrames, value: lookAt },
        ]);
        //easing
        const easingFun = new CubicEase();
        easingFun.setEasingMode(EasingFunction.EASINGMODE_EASEIN);
        anim.setEasingFunction(easingFun);
        return (anim);
    }
    static _setEndPosAndTarget(coreApp) {
        this.mCoreApp = coreApp;
        const tView = coreApp.viewer.view;
        if (tView == null)
            return;
        this.mEndPos = tView.camera.position.clone();
        this.mEndTarget = tView.camera.getTarget().clone();
    }
    static onAfterBack() {
        console.log("finished");
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Animation.mCoreApp = null;
